function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import { useEffect } from 'react';
import debounce from 'lodash/debounce';
export function useFooterAutoWidth(props) {
  var _ref = props || {},
    footerId = _ref.footerId,
    containerId = _ref.containerId,
    hidden = _ref.hidden;
  var setFooterWidth = function setFooterWidth() {
    var _containerDom$getBoun, _containerDom$getBoun2;
    var footerDom = document.getElementById(footerId);
    var containerDom = document.getElementById(containerId);
    var formWidth = containerDom === null || containerDom === void 0 ? void 0 : (_containerDom$getBoun = containerDom.getBoundingClientRect) === null || _containerDom$getBoun === void 0 ? void 0 : (_containerDom$getBoun2 = _containerDom$getBoun.call(containerDom)) === null || _containerDom$getBoun2 === void 0 ? void 0 : _containerDom$getBoun2.width;
    if (footerDom && typeof formWidth === 'number') {
      footerDom.style.width = formWidth + "px";
    }
  };
  var debounceSetFooterWidth = debounce(function () {
    setFooterWidth();
  }, 500, {
    leading: true
  });
  useEffect(function () {
    var containerDom = document.getElementById(containerId);
    setFooterWidth();
    if (ResizeObserver && containerDom) {
      var resizeObserver = new ResizeObserver(function (entries) {
        for (var _iterator = _createForOfIteratorHelperLoose(entries), _step; !(_step = _iterator()).done;) {
          var entry = _step.value;
          debounceSetFooterWidth();
        }
      });
      resizeObserver.observe(containerDom);
    }
  }, [hidden]);
}